import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6c5dc244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12 p-lg-3 p-pb-0" }
const _hoisted_3 = { class: "p-d-flex p-jc-between" }
const _hoisted_4 = { class: "p-mr-2" }
const _hoisted_5 = {
  style: {"height":"200px"},
  class: "p-d-flex p-justify-center p-ai-center"
}
const _hoisted_6 = { class: "p-d-flex p-jc-between" }
const _hoisted_7 = {
  key: 0,
  class: "p-col-12 p-lg-9"
}
const _hoisted_8 = { class: "p-text-center" }
const _hoisted_9 = {
  style: {"gap":"10px"},
  class: "p-d-inline-flex p-mt-3"
}
const _hoisted_10 = { class: "p-text-lowercase" }
const _hoisted_11 = {
  key: 1,
  style: {"min-height":"306px"},
  class: "p-col-12 p-lg-9 p-d-flex p-flex-column p-jc-center p-ai-center"
}
const _hoisted_12 = { class: "p-text-center" }

import { computed, defineAsyncComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "primevue/usetoast";
import { disconnectActivity, setActiveActivity } from "@/graphql/session";
import { EAccessMenu } from "@/graphql/types";
import { activeActivity } from "@/plugins/i18n";
import { useCreateActivity } from "@/graphql/activity/create.activity";
import { useRoles } from "@/hooks/role/useRoles";
import { useUserResponsible } from "@/hooks/responsible/useUserResponsible";
import { cloneDeep } from "@apollo/client/utilities";
import { getAccess, isAdmin } from "@/utils/activity";
import { useWhoAmi } from "@/hooks/user/useWhoAmi";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityTab',
  setup(__props) {

const CreateActivity = defineAsyncComponent(
  () => import("@/components/activity/CreateActivity.vue")
);
const Invitations = defineAsyncComponent(
  () => import("@/components/responsible/Invitations.vue")
);
const UpdateActivity = defineAsyncComponent(
  () => import("@/components/activity/UpdateActivity.vue")
);
const DeleteActivity = defineAsyncComponent(
  () => import("@/components/activity/DeleteActivity.vue")
);
const LeaveActivity = defineAsyncComponent(
  () => import("@/components/activity/LeaveActivity.vue")
);
const ActivityReset = defineAsyncComponent(
  () => import("@/components/activity/ActivityReset.vue")
);
const ActivityBackup = defineAsyncComponent(
  () => import("@/components/activity/ActivityBackup.vue")
);
const ResponsibleC = defineAsyncComponent(
  () => import("@/components/responsible/Responsible.vue")
);
const Subscription = defineAsyncComponent(
  () => import("@/components/subscription/Subscription.vue")
);

const keys = [
  "name",
  "country",
  "address",
  "currency",
  "currencySymbol",
  "taxRate",
];
const { t } = useI18n();
const toast = useToast();
const filterValue = ref(null);
const { roles } = useRoles();
const { Iam } = useWhoAmi();
const layout = window.innerWidth < 768 ? "vertical" : ("horizontal" as any);
const { responsible, selected, setSelected } = useUserResponsible();
const { caLoading, caDialog, createActivity } = useCreateActivity();
const rolesSplit = computed(() => {
  const _roles = roles.value.map(({ id, name }) => ({
    label: name,
    command: () => (filterValue.value = id),
    value: id,
  }));

  return [
    {
      label: t("activity.all"),
      command: () => (filterValue.value = null),
      value: null,
    },
    ..._roles,
  ];
});
const boxOptions = computed(() => {
  return cloneDeep(
    filterValue.value === null
      ? responsible.value
      : responsible.value.filter((res) => res.roleId === filterValue.value)
  );
});
const permissions = computed(() => {
  const acc = getAccess(EAccessMenu.Activity, selected.value?.role?.access);
  const noRestriction = isAdmin() || !selected.value?.roleId;
  return {
    noRestriction,
    update: acc?.update || noRestriction,
    create: acc?.create || noRestriction,
  };
});

const activateActivity = () => {
  setActiveActivity({
    ...selected.value.activity,
    isOwner: selected.value.activity.ownerId === Iam.value.id,
    access: selected.value.role?.access || [],
  });
};

const submitCreateActivity = (event: any) => {
  if (
    responsible.value.find((r) => !r.roleId && r.activity.name === event.name)
  ) {
    toast.add({
      severity: "info",
      summary: t("create.title"),
      detail: t("activity.exist"),
      life: Number(process.env.VUE_APP_TOAST_LIFE),
    });
  } else createActivity(event);
};

const getRole = (id?: number, ownerId?: number) => {
  if (id) {
    return rolesSplit.value.find((role) => role.value === id)?.label;
  }
  if (ownerId === Iam.value.id) {
    return t("activity.owner");
  }
  return "Admin";
};

const activeFilter = computed(() => {
  return filterValue.value ? getRole(filterValue.value) : t("activity.all");
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Listbox = _resolveComponent("Listbox")!
  const _component_SplitterPanel = _resolveComponent("SplitterPanel")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Splitter = _resolveComponent("Splitter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t("activity.list")), 1),
          (_unref(responsible).length && permissions.value.create)
            ? (_openBlock(), _createBlock(_unref(CreateActivity), {
                key: 0,
                rounded: "",
                loading: _unref(caLoading),
                onSubmit: submitCreateActivity,
                dialog: _unref(caDialog),
                "onUpdate:dialog": _cache[0] || (_cache[0] = ($event: any) => (_isRef(caDialog) ? (caDialog).value = $event : null))
              }, null, 8, ["loading", "dialog"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Listbox, {
          "model-value": _unref(selected),
          "onUpdate:modelValue": _unref(setSelected),
          options: boxOptions.value,
          filter: true,
          optionLabel: "activity?.name",
          "filter-fields": ['activity?.name'],
          listStyle: "height:215px;",
          filterPlaceholder: _ctx.$t('search'),
          style: {"min-height":"301px"},
          "data-key": "id"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "p-button-text",
              label: activeFilter.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$refs['my-roles'] as any).toggle($event))),
              "aria-haspopup": "true",
              "aria-controls": "overlay-roles-menu",
              style: {"width":"100%"},
              "icon-pos": "right",
              icon: "pi pi-filter"
            }, null, 8, ["label"]),
            _createVNode(_component_Menu, {
              id: "overlay-roles-menu",
              ref: "my-roles",
              model: rolesSplit.value,
              popup: true
            }, null, 8, ["model"])
          ]),
          empty: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("activity.emptyFilterMessage")), 1)
          ]),
          option: _withCtx(({ option }) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, _toDisplayString(option.activity.name), 1),
              _createVNode(_component_Tag, {
                style: {"height":"15px"},
                severity: "success",
                rounded: "",
                value: getRole(option.roleId, option.activity.ownerId)
              }, null, 8, ["value"])
            ])
          ]),
          _: 1
        }, 8, ["model-value", "onUpdate:modelValue", "options", "filterPlaceholder"])
      ]),
      (_unref(selected)?.activity)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.$tm("activity.active")) + " : " + _toDisplayString(_unref(selected)?.activity?.name), 1),
            _createVNode(_component_Splitter, {
              style: {"min-height":"306px"},
              layout: _unref(layout)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SplitterPanel, { class: "p-d-flex p-flex-column p-ai-center p-jc-center p-p-2" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(keys, (key, index) => {
                        return _createElementVNode("p", { key: index }, _toDisplayString(_ctx.$t(`activity.${key}`)) + " : " + _toDisplayString(index === 1
                  ? _ctx.$tm("activity.countries")[_unref(selected).activity[key]].label
                  : `${_unref(selected).activity[key]}${index === 5 ? "%" : ""}`), 1)
                      }), 64))
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      (permissions.value.noRestriction)
                        ? (_openBlock(), _createBlock(_unref(UpdateActivity), {
                            key: 0,
                            item: _unref(selected).activity
                          }, null, 8, ["item"]))
                        : _createCommentVNode("", true),
                      (permissions.value.noRestriction)
                        ? (_openBlock(), _createBlock(_unref(DeleteActivity), {
                            key: 1,
                            id: _unref(selected).activity.id
                          }, null, 8, ["id"]))
                        : _createCommentVNode("", true),
                      (permissions.value.noRestriction)
                        ? (_openBlock(), _createBlock(_unref(ActivityReset), {
                            key: 2,
                            id: _unref(selected).activity.id
                          }, null, 8, ["id"]))
                        : _createCommentVNode("", true),
                      (permissions.value.noRestriction)
                        ? (_openBlock(), _createBlock(_unref(ActivityBackup), {
                            key: 3,
                            "activity-name": _unref(selected).activity.name,
                            "activity-id": _unref(selected).activity.id
                          }, null, 8, ["activity-name", "activity-id"]))
                        : _createCommentVNode("", true)
                    ]),
                    (!!_unref(selected)?.roleId)
                      ? (_openBlock(), _createBlock(_unref(LeaveActivity), {
                          key: 0,
                          id: _unref(selected).id
                        }, null, 8, ["id"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_SplitterPanel, { class: "p-d-flex p-ai-center p-flex-column p-jc-center p-p-2" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("activity.youAre")) + " ", 1),
                      _createElementVNode("b", _hoisted_10, _toDisplayString(getRole(_unref(selected).roleId, _unref(selected).activity.ownerId)), 1)
                    ]),
                    (_unref(activeActivity).id === _unref(selected).activity.id)
                      ? (_openBlock(), _createBlock(_component_Message, {
                          key: 0,
                          icon: "pi pi-circle-fill",
                          severity: "warn",
                          closable: false
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("activity.activated")) + " ", 1),
                            _createVNode(_component_Tag, {
                              class: "cursor-pointer",
                              icon: "pi pi-sign-out",
                              severity: "danger",
                              rounded: "",
                              onClick: _unref(disconnectActivity)
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          label: _ctx.$t('login'),
                          icon: "pi pi-sign-in",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (activateActivity())),
                          class: "p-button-lg"
                        }, null, 8, ["label"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["layout"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.$t("activity.noSelected")), 1),
            (permissions.value.create)
              ? (_openBlock(), _createBlock(_unref(CreateActivity), {
                  key: 0,
                  loading: _unref(caLoading),
                  onSubmit: submitCreateActivity,
                  "with-label": "",
                  dialog: _unref(caDialog),
                  "onUpdate:dialog": _cache[3] || (_cache[3] = ($event: any) => (_isRef(caDialog) ? (caDialog).value = $event : null))
                }, null, 8, ["loading", "dialog"]))
              : _createCommentVNode("", true)
          ]))
    ]),
    (_unref(activeActivity).id)
      ? (_openBlock(), _createBlock(_component_Splitter, {
          key: 0,
          class: "p-mt-2",
          style: {"min-height":"305px"},
          layout: _unref(layout)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SplitterPanel, { class: "p-d-flex p-flex-column p-ai-start p-p-2" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ResponsibleC))
              ]),
              _: 1
            }),
            _createVNode(_component_SplitterPanel, { class: "p-d-flex p-flex-column p-ai-start p-p-2" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Subscription), {
                  "created-at": _unref(activeActivity).createdAt,
                  payment: _unref(activeActivity).payments[0]
                }, null, 8, ["created-at", "payment"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["layout"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Invitations))
  ], 64))
}
}

})